import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const SvgComponent = ({ stroke = 'white' }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 13L7 7L1 1"
                    stroke={stroke}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 18L10 10L2 2"
                    stroke={stroke}
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={6} height={10} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m1 9 4-4-4-4" stroke={stroke} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SvgComponent;
